import { module as modujs } from "modujs";

export default class extends modujs {
	constructor(m) {
		super(m);

		this.events = {
			click: {
				more: "load",
			},
		};
	}

	init() {
		this.id = this.el.getAttribute("data-module-loader");
		this.$filters = Array.from(document.querySelectorAll("[data-module-filters]")).find((el) => {
			try {
				const config = JSON.parse(el.getAttribute("data-filters-config"));
				return config.for === this.id;
			} catch (e) {
				return false;
			}
		});

		this.batch = parseInt(this.getData("batch"));
		this.$items = this.$("item");
		this.$more = this.$("more")[0];
		this.$batch = this.$("batch")[0];
		this.$progress = this.$("progress")[0];

		// Initially hide the progress bar
		if (this.$progress) {
			this.$progress.style.display = "none";
		}

		// Check if the number of items exceeds the batch size
		if (this.$items.length > this.batch && this.$progress) {
			// Calculate the initial width in percentage
			const initialProgressPercentage = (this.batch / this.$items.length) * 100;

			// Set the CSS variable for the progress bar width
			this.$progress.style.setProperty("--progress-width", `${initialProgressPercentage}%`);

			// Show the progress bar
			this.$progress.style.display = "flex";
		}

		this._filtersAfterHandler = this.reset.bind(this);
		this.$filters.addEventListener("filters:after", this._filtersAfterHandler);
	}

	reset() {
		this.$items.forEach((element) => {
			element.classList.remove("is-loaded");
		});

		this.$batch.innerText = this.batch;

		this.$more.classList.remove("u-hidden");

		this.load();
	}

	load() {
		const $filtered_items = Array.from(this.$items).filter((node) => node.classList.contains("is-match"));

		let lastIndex = Array.from($filtered_items)
			.map((n, i) => (n.classList.contains("is-loaded") ? i + 1 : -1))
			.reverse()
			.find((i) => i !== -1);

		lastIndex = !lastIndex ? 0 : lastIndex;

		const newlyLoadedItems = Array.from($filtered_items).slice(lastIndex, lastIndex + this.batch);

		newlyLoadedItems.forEach((node) => {
			node.classList.add("is-loaded");
		});

		// Calculate the number of currently loaded items
		const numberOfLoadedItems = $filtered_items.filter((node) => node.classList.contains("is-loaded")).length;

		// Update the this.$batch.innerText
		if (this.$batch) {
			this.$batch.innerText = numberOfLoadedItems + " ressources";
		}

		let remaining = $filtered_items.length - (lastIndex + this.batch);

		if (remaining < this.batch && remaining > 0) {
			this.$batch.innerText = remaining; // This part might need adjustment based on your desired behavior
		}

		if (lastIndex + this.batch >= $filtered_items.length) {
			this.$more.classList.add("u-hidden");
		}

		// Update the progress bar width
		if (this.$progress) {
			const currentWidth = parseFloat(getComputedStyle(this.$progress).getPropertyValue("--progress-width"));
			const newProgressPercentage = (numberOfLoadedItems / $filtered_items.length) * 100;
			this.$progress.style.setProperty("--progress-width", `${newProgressPercentage}%`);
		}
	}

	destroy() {
		this.$filters.removeEventListener("filters:after", this._filtersAfterHandler);
	}
}
